// extracted by mini-css-extract-plugin
export default {"productList":"ProductList_productList__2E4CN","productPageList":"ProductList_productPageList__Fxl6R","buttonPagination":"ProductList_buttonPagination__55wn+"};